import React from 'react';

const formatPrice = (price) => Number(price || 0).toFixed(2);

export default function AddOnCircleCard({ addOn, onOpen }) {
  return (
    <button className="ao2-circleBtn" type="button" onClick={onOpen} aria-label={`Edit ${addOn?.name || 'add-on'}`}>
      <div className="ao2-circleThumb" aria-hidden>
        {addOn?.imageUrl ? <img src={addOn.imageUrl} alt="" /> : <div className="ao2-circleFallback">➕</div>}
      </div>
      <div className="ao2-circleLabel" title={addOn?.name || ''}>
        {addOn?.name || 'Untitled'}
      </div>
      <div className="ao2-circleMeta">
        ${formatPrice(addOn?.price)} • {addOn?.duration || 0}m
      </div>
    </button>
  );
}

